import { Model, modelRegistry } from './Model';
import { Client, ReceptionItem } from '.';
import Printable from '../print/Printable';
import { documentHeader, documentLines, documentTable, factLine } from '../print/DocumentLayout';
import Store from '../wrappers/Store';
import { I18n } from '../wrappers/I18n';
import moment from 'moment-timezone';
export class Reception extends Model {
    static entity = 'receptions';
    id = null;
    number = null;
    date = null;
    client_id = null;
    storekeeper = null;
    comment = null;
    created_at = null;
    updated_at = null;
    items = [];
    client;
    reception_type = null;
    register_type = null;
    counterparty_id = null;
    counterparty;
    static fields() {
        return {
            id: this.attr(null),
            number: this.attr(null),
            date: this.attr(null),
            client_id: this.attr(null),
            storekeeper: this.attr(null),
            comment: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            items: this.attr([], (value) => (value || []).map(item => new ReceptionItem(item))),
            client: this.attr(undefined, value => value ? new Client(value) : undefined),
            reception_type: this.attr(null),
            register_type: this.attr(null),
            counterparty_id: this.attr(null),
            counterparty: this.attr(undefined),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    /** Auto-created mirror of an internal dispatch from another venue — read-only here. */
    isInternal() {
        return this.reception_type === 'int' && !this.register_type;
    }
    getPrintable() {
        const pr = new Printable();
        const venue = Store.get('tenant')?.venue;
        if (!venue)
            return pr;
        documentHeader(pr, {
            title: I18n.t('general.reception'),
            facts: factLine([I18n.t('general.number'), this.number], [I18n.t('general.date'), moment(this.date).format('DD.MM.YYYY.')]),
            venueName: venue.name,
            venueLine: `${I18n.t('general.tax_id_number')}: ${venue.tax_id_number}`,
        });
        documentLines(pr, [
            factLine([I18n.t('general.supplier'), this.counterparty?.name || this.client?.name]),
            factLine([I18n.t('general.received_by'), this.storekeeper]),
            factLine([I18n.t('general.comment'), this.comment]),
        ]);
        const columns = [
            { label: I18n.t('general.number'), kind: 'index' },
            { label: I18n.t('general.code'), kind: 'code' },
            { label: I18n.t('general.inventory_item'), kind: 'name' },
            { label: I18n.t('general.quantity'), kind: 'figure' },
        ];
        const rows = this.items.map((item, index) => [
            String(index + 1),
            item.getProduct()?.code || '',
            item.getProduct()?.name || '',
            `${item.getCount()} ${item.getProduct()?.getUnitOfMeasureSold() || item.getProduct()?.getUnitOfMeasure() || ''}`,
        ]);
        documentTable(pr, columns, rows, { density: 'regular' });
        return pr;
    }
}
export default Reception;
modelRegistry.register('Reception', Reception);
//# sourceMappingURL=Reception.js.map